import { render } from "./CategoryIcon.vue?vue&type=template&id=3367eb55"
import script from "./CategoryIcon.vue?vue&type=script&lang=js"
export * from "./CategoryIcon.vue?vue&type=script&lang=js"
script.render = render

export default script